import React, { useRef, useEffect, useCallback } from 'react'
import { Container } from '@sencha/ext-modern'
import { useInstData } from 'tyan/public/hooks'
import { showContextMenu } from 'tyan/public/components/column/contextmenu'
import JoyusingV1 from './JoyusingV1'
import Capture from './Capture'
import showCordovaCamera from './cordovaCamera'

// require('../../tyanInit')
const ignoreOSs = ['Android', 'iOS']

const FileInput = () => {
	const { me } = useInstData()

	const handleChange = useCallback((e) => me.onGetFiles && me.onGetFiles(e.fromDragger && e.files ? e.files : e.target.files), [])

	// 20230620 王玮 修改为调用可使用一个对象参数，判断条件为onGetFiles.__proto__.constructor.name='Object', 并增加参数eventArg
	// 20230620 王玮 增加高拍仪
	// 20230920 王玮 enableJoyusingV1 高拍仪增加参数判断, true, false由参数判断，否则由Tyan.appSettings.fileServerInfo.joyusingV1 确定
	// 20230920 王玮 增加参数 onlyFiles，主要用于FileImport ??? 20240307
	// 20230307 王玮 增加参数 enablePaste
	const getFiles = useCallback((onGetFiles, accept = null, multiple = false, enableCapture, enableJoyusingV1, enablePaste) => {
		let event = window.event
		if (onGetFiles && onGetFiles.__proto__.constructor.name === 'Object') {
			accept = onGetFiles.accept || null
			multiple = onGetFiles.multiple || false
			enableCapture = onGetFiles.enableCapture
			enableJoyusingV1 = onGetFiles.enableJoyusingV1
			enablePaste = onGetFiles.enablePaste
			event = onGetFiles.event || window.event

			// 保持在最后
			onGetFiles = onGetFiles.onGetFiles
		}

		const showSelector = selector => {
			const pos = event
				? event.changedTouches
					? [event.changedTouches[0].clientX, event.changedTouches[0].clientY]
					: [event.x, event.y]
				: [window.innerWidth / 2, window.innerHeight / 2]

			// console.log('event:', event)
			// console.log('event pos:', pos)
			setTimeout(() => showContextMenu(
				pos,
				selector
			))

			// me.input.click()
		}

		me.onGetFiles = onGetFiles
		me.input.accept = accept
		me.input.multiple = multiple
		me.input.value = ''

		const capturePhoto = ({ }) => {
			navigator.camera
				? showCordovaCamera(onGetFiles)
				: Tyan.pubForm.showDialog('拍照', Capture, { onGetFiles, accept }, { closable: true, draggable: true })
		}

		const doJoyusingV1 = () => {
			Tyan.pubForm.showDialog('高拍仪', JoyusingV1, { onGetFiles, accept }, { closable: true, draggable: true })
		}

		const handlePasteFile = () => {
			const saveImg = () => new Promise((resolve, reject) => {
				Tyan.wsFrontEditor.SaveClipbrdImgBuff(({ ret }) => {
					const arr = ret.split('|').filter(o => o && !o.endsWith('\\'))
					arr.length ? resolve(arr) : reject('没有被复制的可用文件')
				})
			})

			saveImg()
				.then(onGetFiles)
				.catch(e => alert(e))
		}

		const selector = [];

		true
			&& (navigator.camera || (enableCapture && !ignoreOSs.includes(Ext.os.name) && (location.protocol === 'https:' || location.hostname === 'localhost')))
			&& selector.push({ text: '拍照上传', ui: 'action', handler: capturePhoto });

		true && (enableJoyusingV1 || (enableJoyusingV1 != false && Tyan.appSettings.fileServerInfo.joyusingV1))
			&& selector.push({ text: '高拍仪', ui: 'action', handler: doJoyusingV1 });

		true && enablePaste && Tyan.wsFrontEditor.Connected()
			&& selector.push({ text: '粘贴', ui: 'action', handler: handlePasteFile })

		selector.length
			? (selector.push({ text: '选择文件', ui: 'action', handler: () => me.input.click() }), showSelector(selector))
			: me.input.click()
	}, [])

	useEffect(() => {
		Tyan.pubForm.getFileInput = getFiles
		return () => delete Tyan.pubForm.getFileInput
	}, [])

	return <Container maxWidth='0'>
		<div style={{ display: 'none' }}>
			<input
				ref={ref => ref && me.input !== ref && (me.input = ref)}
				onChange={handleChange}
				style={{ display: 'none' }}
				type="file"
			/>
		</div>
	</Container>
}

export default FileInput